module.exports = __webpack_public_path__ + "img/延胡索（元胡）.2ed70feb.jpg";